import type { QueryResponse, SnapshotResponse } from '../api';

interface Props {
  result: QueryResponse | null;
  queryError: string | null;
  snapshot: SnapshotResponse | null;
  snapshotError: string | null;
}

export function AnswerPanel({ result, queryError, snapshot, snapshotError }: Props) {
  return (
    <div>
      {queryError && <div className='error-banner'>Query failed: {queryError}</div>}

      {result ? (
        <>
          <div className='answer'>{result.answer}</div>
          {result.regions.length > 0 && (
            <div className='regions-list'>
              Highlighted:&nbsp;
              {result.regions.map(r => (
                <code key={r}>{r}</code>
              ))}
            </div>
          )}
        </>
      ) : (
        !queryError && (
          <div className='answer' style={{ color: '#666' }}>
            Type a question above. Examples: "what is S3★ doing right now?", "any recent algedonic
            signals?", "is the SudoBlog cadence drained?", "what mode is the substrate in?".
          </div>
        )
      )}

      <div className='snapshot-block'>
        <h3>Substrate snapshot</h3>
        {snapshotError && <div className='error-banner'>{snapshotError}</div>}
        {!snapshot && !snapshotError && <div>Loading…</div>}
        {snapshot && (
          <>
            {snapshot.daemons.map(d => (
              <div className='daemon-row' key={d.name}>
                <span>
                  <span className={`dot ${d.healthy ? 'green' : 'red'}`} />
                  {d.name}
                </span>
                <span style={{ color: '#888' }}>
                  {d.last_tick_age_ms != null ? `${Math.round(d.last_tick_age_ms / 1000)}s` : '—'}
                </span>
              </div>
            ))}
            {snapshot.mode && (
              <div style={{ marginTop: 8, color: '#555' }}>
                mode:{' '}
                <code>
                  {String(
                    (snapshot.mode as { operating_mode?: string }).operating_mode || 'unknown'
                  )}
                </code>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}
